import React from "react";
import { X } from "lucide-react";

import ButtonV2 from "../button/v2";
import { cn } from "../../../lib/utils";

interface ConfirmModalProps {
  title: string;
  description: string;
  cancelLabel?: string;
  confirmLabel?: string;
  isLoading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  className?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title,
  description,
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
  isLoading = false,
  onCancel,
  onConfirm,
  className,
}) => (
  <div
    className="fixed inset-0 z-[9999] flex items-center justify-center bg-[rgba(10,10,10,0.20)]"
    onClick={onCancel}
  >
    <div
      onClick={(event) => event.stopPropagation()}
      className={cn(
        `
          relative
          w-[439px]
          rounded-[10px] border border-[#E5E5E5] bg-white
          p-6
          shadow-[0_10px_15px_-3px_rgba(0,0,0,0.10),0_4px_6px_-4px_rgba(0,0,0,0.10)]
        `,
        className,
      )}
    >
      <button
        type="button"
        onClick={onCancel}
        aria-label="Close dialog"
        className="absolute right-4 top-4 flex h-4 w-4 items-center justify-center"
      >
        <X size={16} className="text-[#0A0A0A] opacity-70" />
      </button>

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1.5">
          <h2 className="text-center text-[18px] font-semibold leading-[18px] text-[#0A0A0A]">
            {title}
          </h2>

          <p className="text-center text-[14px] font-normal leading-5 text-[#737373]">
            {description}
          </p>
        </div>

        <div className="flex items-center gap-2">
          <ButtonV2
            variant="outline"
            size="md"
            onClick={onCancel}
            disabled={isLoading}
            className="h-9 flex-1 rounded-[8px] border-[#E5E5E5]"
          >
            {cancelLabel}
          </ButtonV2>

          <ButtonV2
            variant="primary"
            size="md"
            onClick={onConfirm}
            loading={isLoading}
            className={cn(
              "h-9 flex-1 rounded-[8px] text-[#FAFAFA]",
              "bg-[linear-gradient(180deg,#788AF7_0%,#3551F3_100%)]",
            )}
          >
            {confirmLabel}
          </ButtonV2>
        </div>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
